import styles from "./error.module.css";
import { ErrorItemDataValue } from "@src/autoDebit/constant";

interface ErrorProps {
  children?: React.ReactNode[];
}
const Error: React.FC<ErrorProps> = ({ children }) => (
  <ul data-component="Error">
    {children?.map((error, i) => (
      <li data-component={ErrorItemDataValue} key={i} className={styles.text}>
        {error}
      </li>
    ))}
  </ul>
);

export default Error;
